import React from 'react';

const RoomsContext = React.createContext();

export default RoomsContext;